__turbopack_context__.v({
  "app_light_theme": "Footer-module-scss-module__ygM31a__app_light_theme",
  "content": "Footer-module-scss-module__ygM31a__content",
  "footer": "Footer-module-scss-module__ygM31a__footer",
  "iconList": "Footer-module-scss-module__ygM31a__iconList",
});
